import { application } from "./application"

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import LangController from "./lang_controller"
application.register("lang", LangController)

import HeroController from "./hero_controller"
application.register("hero", HeroController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import PwaController from "./pwa_controller"
application.register("pwa", PwaController)

import TopController from "./top_controller"
application.register("top", TopController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import FormController from "./form_controller"
application.register("form", FormController)
